import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { LocationManagerModule } from '../../location-manager/location-manager.module';
import { LocationManagerDialogComponent } from './location-manager-dialog.component';

@NgModule({
  imports: [CommonModule, LocationManagerModule, MatDialogModule],
  exports: [LocationManagerDialogComponent],
  declarations: [LocationManagerDialogComponent]
})
export class LocationManagerDialogModule {}
